// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xProductDetailsStateType = Readonly<{
    isProductLoading: { [key: string]: boolean };
}>;

export const initialxProductDetailsState: xProductDetailsStateType = {
    isProductLoading: {},
};

const reducer = {
    "xProductDetails/isProductLoading": (
        draft: Draft<xProductDetailsStateType>,
        action: { isProductLoading: boolean; productPath: string },
    ) => {
        draft.isProductLoading[action.productPath] = action.isProductLoading;
    },
};

const xProductDetails = createTypedReducerWithImmer(initialxProductDetailsState, reducer);

(reducers as any).xProductDetails = xProductDetails;

export type xProductDetailsState = {
    xProductDetails: xProductDetailsStateType;
} & ApplicationState;

type xProductDetailsReducers = {
    [key: string]: typeof xProductDetails;
};

export type xProductDetailsActions = Parameters<xProductDetailsReducers[keyof xProductDetailsReducers]>[1] | AnyAction;
